import React from "react";
import {
    PRESENCE_DICTIONARY,
    PRESENCE_TO_HINT,
    HIDDEN_PRESENCES,
    PRESENCE_TO_ICON_COMPONENT,
    ABSENT_PRESENCES,
    PRESENT_PRESENCES,
    SELECTABLE_PRESENCES,
} from "consts";
//
import { Box, SvgIcon } from "@material-ui/core";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const PresenceAutoSuggest = (props) => {
    const suggestPresence = (q) => {
        const { hideAbsences, absent, isUop, isMark } = props;

        if (q) {
            q = q.toLocaleLowerCase();
        }

        if (isUop) {
            return Promise.resolve(
                (absent && !hideAbsences ? ABSENT_PRESENCES : PRESENT_PRESENCES)
                    .filter((presenceKey) => (PRESENCE_DICTIONARY[presenceKey] || "")
                        .toLocaleLowerCase()
                        .includes(q)
                )
            );
        } else {
            return Promise.resolve(
                (isMark ? SELECTABLE_PRESENCES : PRESENT_PRESENCES)
                    .filter((presenceKey) => (PRESENCE_DICTIONARY[presenceKey] || "")
                        .toLocaleLowerCase()
                        .includes(q)
                )
            );
        }
    }

    const OptionIcon = ({ Icon }) => (
        <Box component="span" color="text.secondary" width={24} height={24}>
            <SvgIcon component={Icon} color="inherit" className="autoSuggest--icon" />
        </Box>
    );

    return (
        <AutoSuggest
            label="Presence"
            fetchOptions={suggestPresence}
            disabled={HIDDEN_PRESENCES.includes(props.value)}
            renderOption={(presenceKey) => ({
                value: presenceKey,
                label: PRESENCE_DICTIONARY[presenceKey],
                icon: <OptionIcon Icon={PRESENCE_TO_ICON_COMPONENT[presenceKey]} />,
                hint: PRESENCE_TO_HINT[presenceKey],
            })}
            optionIdentifier={(value) => value}
            {...props}
        />
    );
}

export default PresenceAutoSuggest;
